export default function TermsContentEn() {
  return (
    <div className="px-4">
      <h1 className="text-xl sm:text-2xl font-bold text-dark mb-4">Terms and Conditions</h1>

      <p className="text-sm text-dark leading-relaxed mb-3">
        Honda Safety Thailand Website. The website https://hondasafety.thaihonda.co.th is established and
        operated by Traffic Safety Promotional Function, Thai Honda Co., Ltd. (&quot;the
        Company&quot;), a company registered in Thailand. The use of information presented
        through the website or other communication systems of the Company is subject to the
        following terms and conditions:
      </p>

      <h2 id="terms-section-1" className="text-base sm:text-lg font-bold text-dark mb-3 mt-6">
        1. Intellectual Property
      </h2>
      <p className="text-sm text-dark leading-relaxed mb-3">
        1.1 You acknowledge that the Company is the owner of all information, images, sounds,
        patterns, designs, business ideas, trademarks, service marks, trade names, and all
        other intellectual property on the website (&quot;Company Property&quot;).
      </p>
      <p className="text-sm text-dark leading-relaxed mb-3">
        1.2 You agree not to copy, modify, imitate, or use the Company Property for commercial,
        business, or personal benefit, or for any other purpose that may violate the
        Company&apos;s rights. Such actions may cause damage or loss of reputation to the
        Company, or mislead third parties regarding your status or the Company&apos;s status,
        unless written consent is obtained from the Company.
      </p>
      <p className="text-sm text-dark leading-relaxed mb-3">
        1.3 You represent and warrant that the text or information you provide in connection
        with the use of the website, such as membership registration, does not violate the rights
        of others and is truthful.
      </p>

      <h2 id="terms-section-2" className="text-base sm:text-lg font-bold text-dark mb-3 mt-6">
        2. Website Usage
      </h2>
      <p className="text-sm text-dark leading-relaxed mb-3">
        2.1 You consent to the Company collecting the personal information you have provided
        and your website usage data. The Company has the right to use such data as specified in
        our Privacy Policy.
      </p>
      <p className="text-sm text-dark leading-relaxed mb-3">
        2.2 You agree not to engage in the following: using automated software, hacking database
        systems, or modifying/altering data access via other software to collect or store
        information from the Company&apos;s services.
      </p>

      <h2 id="terms-section-3" className="text-base sm:text-lg font-bold text-dark mb-3 mt-6">
        3. Limitation of Liability
      </h2>
      <p className="text-sm text-dark leading-relaxed mb-3">
        3.1 The Company shall not be liable for any damages to any person arising from the use
        of the website, its information, or recommendations, including data transmission,
        website linking, transactions, or any other actions related to the Company&apos;s rights
        under these terms or by law.
      </p>
      <p className="text-sm text-dark leading-relaxed mb-3">
        3.2 You agree to waive all rights to pursue civil or criminal legal action against the
        Company, its directors, employees, and agents resulting from activities or events
        specified in Clause 3.1 or any other cause related to website usage.
      </p>

      <h2 id="terms-section-4" className="text-base sm:text-lg font-bold text-dark mb-3 mt-6">
        4. Membership Registration
      </h2>
      <p className="text-sm text-dark leading-relaxed mb-3">
        4.1 To use services, book training courses, or exercise Member Club rights, you must
        register as a member by providing truthful and current information according to the
        categories specified by the Company.
      </p>
      <p className="text-sm text-dark leading-relaxed mb-3">
        4.2 You must not use an alias that is the real name of another person with the intent to
        mislead the public or cause damage/reputation loss to that person.
      </p>
      <p className="text-sm text-dark leading-relaxed mb-3">
        4.3 You must not create automated user accounts, forge user data, or send electronic
        messages that disturb other users. You must not transmit viruses, worms, Trojans, or
        other harmful programs, or intentionally overload the website without reasonable cause.
      </p>
      <p className="text-sm text-dark leading-relaxed mb-3">
        4.4 You cannot change the First Name and Last Name on a course completion certificate
        after the initial confirmation. If a change is necessary, a request must be submitted to
        the company; the decision shall be made by the company.
      </p>
      <p className="text-sm text-dark leading-relaxed mb-3">
        4.5 You understand that your data, including course bookings or registrations, is linked
        to your account email. The Company is not responsible for any impact resulting from a
        change in the account email.
      </p>

      <h2 id="terms-section-5" className="text-base sm:text-lg font-bold text-dark mb-3 mt-6">
        5. Reservation of Rights
      </h2>
      <p className="text-sm text-dark leading-relaxed mb-3">
        5.1 The Company reserves the right to amend, change, or add to these Terms and
        Conditions without prior notice, and you agree to comply with such updated terms.
      </p>
      <p className="text-sm text-dark leading-relaxed mb-3">
        5.2 The Company reserves the right to disapprove, cancel, or suspend your usage or
        membership status, either temporarily or permanently, without needing to provide a reason
        or prior notice.
      </p>

      <h2 id="terms-section-6" className="text-base sm:text-lg font-bold text-dark mb-3 mt-6">
        6. Service Cancellation and Refund Policy
      </h2>
      <p className="text-sm text-dark leading-relaxed mb-3">
        6.1 If you violate or fail to comply with any part of Terms of Service of the website,
        the company reserves the right to suspend or cancel your service immediately without
        prior notice. You agree that all expenses already paid are non-refundable in all cases.
      </p>
      <p className="text-sm text-dark leading-relaxed mb-3">
        6.2 In cases where your actions cause damage to the website or related agencies, the
        website reserves the right to take legal action as appropriate. The company reserves the
        right not to accept cancellations, changes, or edits to course bookings in the following
        cases:
      </p>
      <ul className="list-disc ml-4 mb-3">
        <li className="text-sm text-dark leading-relaxed mb-1">
          Errors caused by the user, such as choosing the wrong course, duplicate bookings, or
          incorrect data entry.
        </li>
        <li className="text-sm text-dark leading-relaxed mb-1">
          Changes in course prices based on marketing policies or strategies.
        </li>
        <li className="text-sm text-dark leading-relaxed mb-1">
          Cases involving Gift Vouchers, Coupons, or any discounts, including forgetting to apply a
          discount or requesting to use one later.
        </li>
        <li className="text-sm text-dark leading-relaxed mb-1">
          Cases of &quot;Change of Mind&quot; for any reason.
        </li>
      </ul>
      <p className="text-sm text-dark leading-relaxed mb-3">
        By making a course booking through the website, it is deemed that you have read,
        understood, and accepted these terms.
      </p>

      <h2 id="terms-section-7" className="text-base sm:text-lg font-bold text-dark mb-3 mt-6">
        7. Governing Law
      </h2>
      <p className="text-sm text-dark leading-relaxed mb-3">
        The use of this website and dispute resolution shall be governed by the laws of Thailand.
      </p>
    </div>
  );
}
